module.exports = __webpack_public_path__ + "img/printLogo.4b5639f7.png";